<template>
  <div class="box">
    <div class="heard">
       <div class="left">
           <div class="tq"></div>
           <iframe width="400" scrolling="no" height="47" frameborder="0" allowtransparency="true" src="https://i.tianqi.com?c=code&id=86&color=%23FFFFFF&icon=1&py=mianxian&site=20"></iframe>
       </div>
       <div class="center">{{VUE_APP_PLATFORM_NAME}}</div>
       <div class="right">
          <span class="time">{{date}}</span>
           <span class="time1">{{nowTime}}</span>
       </div>
    </div>

    <div class="m-content" >
      
      <div class="content">
          <div class="content-item">
            <a class="nav-menu p1" target="_blank" href="/fangfp/#">
              <img src="@/assets/ffp-bg.png" class="img"/>
            </a>
             <a class="nav-menu p3" target="_blank" href="/zhshj/#">
              <img src="@/assets/zdrjc-bg.png" class="img"/>
            </a>
             <a class="nav-menu p2" target="_blank" href="/zhshj/#">
              <img src="@/assets/wgh-bg.png" class="img"/>
            </a>
          </div>
          <div class="content-item d2">
             <a class="nav-menu p4" target="_blank" href="/xmgli/#">
              <img src="@/assets/xczx-bg.png" class="img"/>
            </a>
             <a class="nav-menu p5" target="_blank" href="/fangfp/#">
              <img src="@/assets/xczxzcgl-bg.png" class="img"/>
            </a>
            <div style="float:right">
             <a class="nav-menu p6" target="_blank" href="/404/#">
              <img src="@/assets/wlw-bg.png" class="img"/>
            </a>
             <a class="nav-menu p6" target="_blank" href="/zdjsxm/#">
              <img src="@/assets/zdjsxm-bg.png" class="img"/>
            </a>
             <a class="nav-menu p6" target="_blank" href="/zhshj/#">
              <img src="@/assets/zhzl-bg.png" class="img"/>
            </a>
             <a class="nav-menu p6" target="_blank" href="/fgdj/#">
              <img src="@/assets/fgdj-bg.png" class="img"/>
            </a>
             <a class="nav-menu " target="_blank" href="/zhshj/#">
              <img src="@/assets/mdjf-bg.png" class="img"/>
            </a>
            </div>
          </div> 
           <div class="content-item " style="top:-18px">
             <a class="nav-menu" target="_blank" href="/zhyq/#">
              <img src="@/assets/qyfw-bg.png" class="img"/>
            </a>
             <a class="nav-menu p7" target="_blank" href="/xfbf/#">
              <img src="@/assets/xfbf-bg.png" class="img"/>
            </a>
             <a class="nav-menu p8"  target="_blank" href="/ly/#">
              <img src="@/assets/zhly-bg.png" class="img"/>
            </a>
             <a class="nav-menu  ml40"  style="margin-left:44px" target="_blank" href="/zhsj/#">
              <img src="@/assets/mxsz-bg.png" class="img"/>
            </a>
             <a class="nav-menu  ml40"  style="margin-left:44px" target="_blank" href="http://172.18.50.10">
              <img src="@/assets/rhtx-bg.png" class="img"/>
            </a>
            
          </div> 
          <div class="content-item " style="top:-18px">
             <a class="nav-menu p4" target="_blank" href="/yqfk/#">
              <img src="@/assets/yqfk-bg.png" class="img"/>
            </a>
             <a class="nav-menu p5" target="_blank" href="/zhsj/#">
              <img src="@/assets/zhzf-bg.png" class="img"/>
            </a>
             <a class="nav-menu ml40" target="_blank" href="/yj/#">
              <img src="@/assets/yjfz-bg.png" class="img"/>
            </a>
             <a class="nav-menu ml40" target="_blank" href="/yj/#">
              <img src="@/assets/yjywgl-bg.png" class="img"/>
            </a>
             <a class="nav-menu ml42" target="_blank" @click="clickMenu('bigDataIndex')">
              <img src="@/assets/szls-bg.png" class="img"/>
            </a>
             <a class="nav-menu ml42" target="_blank" href="http://36.137.171.204:19008/index.html#/login?redirect=%2Fdashboard">
              <img src="@/assets/sjjh-bg.png" class="img"/>
            </a>
            
          </div> 


      </div>


      <!-- <a class="nav-menu" target="_blank" href="/yqfk/#">
         <img src="@/assets/yqfk-bg.png" class="img"/>
         <span class="text">疫情防控</span>
      </a>
      <a class="nav-menu" target="_blank" href="/fangfp/#">
           <img src="@/assets/ffp-bg.png" class="img"/>
         <span class="text">防返贫</span>
      </a>
      <a class="nav-menu" target="_blank" href="/zhshj/#">
            <img src="@/assets/zzxt-bg.png" class="img"/>
         <span class="text">综治系统</span>
      </a>
      <a class="nav-menu" target="_blank" href="/zhyq/#">
            <img src="@/assets/zhyq-bg.png" class="img"/>
         <span class="text">智慧园区</span>
      </a>
      <a class="nav-menu" target="_blank" href="/yj/#">
             <img src="@/assets/yjxm-bg.png" class="img"/>
         <span class="text">应急项目</span>
      </a>
      <a class="nav-menu" target="_blank" href="/xmgli/#">
         <img src="@/assets/xmgl-bg.png" class="img"/>
         <span class="text">项目管理</span>
      </a>
      <a class="nav-menu" target="_blank" href="/xfbf/#">
         <img src="@/assets/xfbf-bg.png" class="img"/>
         <span class="text">消费帮扶</span>
      </a>
      <a class="nav-menu" target="_blank" href="/ly/#">
         <img src="@/assets/zhly-bg.png" class="img"/>
         <span class="text">智慧旅游</span>
      </a>
        <a class="nav-menu" target="_blank" href="/404/#">
         <img src="@/assets/zhdp-bg.png" class="img"/>
         <span class="text">智慧大屏</span>
      </a>
      <a class="nav-menu" target="_blank" href="/404/#">
            <img src="@/assets/sjzx-bg.png" class="img"/>
         <span class="text">数据中心</span>
      
      </a>
      <a class="nav-menu" target="_blank" href="/404/#">
            <img src="@/assets/wlw-bg.png" class="img"/>
         <span class="text">物联网平台</span>
      </a>

      <a class="nav-menu" target="_blank" href="/admin/#">
         <img src="@/assets/xtsz-bg.png" class="img"/>
         <span class="text">系统管理</span>
      </a> -->
      
    </div>
  </div>
</template>

<script>
  import IndexChart from './IndexChart'
  import IndexTask from "./IndexTask"
  import IndexBdc from './IndexBdc'
  import IndexSimple from './IndexSimple'
   import Vue from 'vue'
  import { ACCESS_TOKEN } from "@/store/mutation-types"

  export default {
    name: "Analysis",
    components: {
      IndexChart,
      IndexTask,
      IndexBdc,
      IndexSimple
    },
    data() {
      return {
        indexStyle:0,
        nowTime:'',
        date:'',
      }
    },
    created() {
      this.nowTimes();
    },
    methods: {
       //显示当前时间（年月日时分秒）
              timeFormate(timeStamp) {
                let year = new Date(timeStamp).getFullYear();
                let month =new Date(timeStamp).getMonth() + 1 < 10? "0" + (new Date(timeStamp).getMonth() + 1): new Date(timeStamp).getMonth() + 1;
                let date =new Date(timeStamp).getDate() < 10? "0" + new Date(timeStamp).getDate(): new Date(timeStamp).getDate();
                let hh =new Date(timeStamp).getHours() < 10? "0" + new Date(timeStamp).getHours(): new Date(timeStamp).getHours();
                let mm =new Date(timeStamp).getMinutes() < 10? "0" + new Date(timeStamp).getMinutes(): new Date(timeStamp).getMinutes();
                let ss =new Date(timeStamp).getSeconds() < 10? "0" + new Date(timeStamp).getSeconds(): new Date(timeStamp).getSeconds();
                let weekArr = [ '星期天','星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
                let week = weekArr[timeStamp.getDay()];
                this.date = year + "年" + month + "月" + date +"日"+"     "+week;
                this.nowTime =  hh+":"+mm+':'+ss ;
              },
              nowTimes(){
                this.timeFormate(new Date());
                setInterval(this.nowTimes,1000);
                this.clear()
              },
              clear(){
                clearInterval(this.nowTimes)
                this.nowTimes = null;
              },
              clickMenu(path){
               let token =  Vue.ls.get(ACCESS_TOKEN); 
               let url =  window._CONFIG['bigscreenUrl']+`/wh-zhshjzx-mx/${path}?token=${token}`;
               window.open(url, '_blank')
              } 

    }
  }
</script>

<style lang="less" scoped>
a.nav-menu {
  display: inline-block;
  position: relative;
 
}

.img{
  
  width: 156px;
  height:172px ;
}

.text{
  position: absolute;
  width: 100%;
  font-size: 3vmin;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 59px;
  letter-spacing: 4px;
  bottom: 27%;
  left: 0px;
  text-align: center;
}



  .m-content{
    overflow: auto;
    height: 92%;
    padding-top: 30px;
    .content{
      margin: 0 44px ;
      height: 824px;
      background:  url(~@/assets/pg-bg.png) no-repeat;
      background-size: cover;
      transform:scale(0.9);
    }
  }

.box{
    height: 100vh;
    background: #1890ff url(~@/assets/index-bg.png) no-repeat;
    background-size: cover;
    background-position-x: left;
    background-position-y: top;
}
.heard{
   width: 100%;
   height: 8%;
   background: transparent url(~@/assets/index-heard-bg.png) no-repeat;
   background-position-x: center;
   background-position-y: top;
   text-align: center;
   

  .left{
    width: 30%;
    height: 100%;
    float: left;
    display: flex;
    align-items: center;
    padding-left: 60px;
  }

  .right{
    width: 30%;
     height: 100%;
     float: right;
     display: flex;
     align-items: center;
     justify-content: flex-end;
     padding-right: 67px;
     color: #EBF9FF;
     .time{
      font-size: 21px;
      margin-right: 12px;
     }
     .time1{
        font-size: 32px;
     }
  }

  .center{
    width: 40%;
    height: 100%;
    display: inline-block;
    font-size: 4vmin;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 63px;
    letter-spacing: 7px;
    text-shadow: 3px 2px 0px #296DCC;
  }

}
.tq{
  position: absolute;
  background: transparent;
  width: 500px;
  height: 100px;
  z-index: 1;
}

.content-item{
  position: relative;

  .p1{
    margin-left: 196px;
  }

  .p2{
    float: right;
    right:139px;

  }
  .p3{
   float: right;
   right:100px;
  }

   .p4{
   margin-left:99px;
  }

  .p5{
   margin-left:40px;
  }

  .p6{
    margin-right: 40px;
  }

  .p7{
    margin-left: 40px;
  }

  .p8{
    margin-left: 434px;
  }
}

.d2{
  top: -12px;
}

.ml40{
  margin-left: 40px;
}
.ml42{
  margin-left: 42px;
}


@media screen and (min-height: 1020px) {
   .m-content{
    padding-top: 120px;
  }
}

</style>
<style >
   ::-webkit-scrollbar { display: none; }
</style>